export function voicemailStateKey(sessionId, callSid) {
    return `${sessionId}:${callSid}`;
}

export async function loadVoicemailState(client, orgId) {
    if (!client || !orgId) throw new Error('Could not load voicemail state without an organization scope.');
    const { data, error } = await client
        .from('communications_voicemail_state')
        .select('org_id, session_id, call_sid, heard_at, archived_at, deleted_at')
        .eq('org_id', orgId);

    if (error) throw error;
    return (data || []).reduce((states, row) => {
        states[voicemailStateKey(row.session_id, row.call_sid)] = row;
        return states;
    }, {});
}

export async function saveVoicemailState(client, { orgId, sessionId, callSid, changes }) {
    if (!client || !orgId || !sessionId || !callSid) {
        throw new Error('Could not update voicemail state without an organization, conversation, and call.');
    }

    const allowedFields = ['heard_at', 'archived_at', 'deleted_at'];
    const update = Object.fromEntries(
        Object.entries(changes || {}).filter(([field, value]) => allowedFields.includes(field) && value),
    );
    if (Object.keys(update).length === 0) throw new Error('Choose a voicemail state change to save.');

    const row = {
        org_id: orgId,
        session_id: sessionId,
        call_sid: callSid,
        ...update,
        updated_at: new Date().toISOString(),
    };
    const { data, error } = await client
        .from('communications_voicemail_state')
        .upsert(row, { onConflict: 'org_id,session_id,call_sid' })
        .select('org_id, session_id, call_sid, heard_at, archived_at, deleted_at')
        .single();

    if (error) throw error;
    return data;
}
